import { MD5 } from "crypto-js";

export const md5Hash = (str) => {
  return MD5(str).toString();
};

export const getAnonymPass = () => {
  var f = new Date();
  var day = ("0" + f.getDate()).slice(-2).toString();
  var month = ("0" + (f.getMonth() + 1)).slice(-2).toString();
  var year = f.getFullYear().toString();
  var key = "grupo" + day + "cs" + month + "ahorro" + year + "credito";
  var pass = md5Hash(key);
  return pass;
};

export const capitalize = (word) => {
  return word[0].toUpperCase() + word.slice(1);
};

export const setCache = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getCache = (key) => {
  let content = localStorage.getItem(key);
  return content !== null
    ? localStorage.getItem(key).replace(/['"]+/g, "")
    : null;
};

export const orderArray = (array, field) => {
  return array.sort(function (a, b) {
    if (a.field < b.field) {
      return -1;
    }
    if (a.field > b.field) {
      return 1;
    }
    return 0;
  });
};

export const replaceAll = (text, busca, reemplaza) => {
  while (text.toString().indexOf(busca) !== -1)
    text = text.toString().replace(busca, reemplaza);
  return text;
};

export const cleanValue = (value) => {
  value = replaceAll(value, ".", "");
  value = replaceAll(value, ",", "");
  value = replaceAll(value, ";", "");
  value = replaceAll(value, "-", "");
  value = replaceAll(value, "_", "");
  value = replaceAll(value, "/", "");
  value = replaceAll(value, "+_", "");
  value = replaceAll(value, "*", "");
  value = replaceAll(value, "|", "");
  value = replaceAll(value, "°", "");
  value = replaceAll(value, "!", "");
  value = replaceAll(value, "#", "");
  value = replaceAll(value, "$", "");
  value = replaceAll(value, "%", "");
  value = replaceAll(value, "&", "");
  value = replaceAll(value, "\\", "");
  value = replaceAll(value, "(", "");
  value = replaceAll(value, ")", "");
  value = replaceAll(value, "=", "");
  value = replaceAll(value, "'", "");
  value = replaceAll(value, "¿", "");
  value = replaceAll(value, "'", "");
  value = replaceAll(value, "?", "");
  value = replaceAll(value, "{", "");
  value = replaceAll(value, "}", "");
  value = replaceAll(value, "[", "");
  value = replaceAll(value, "]", "");

  value = value.split(" ");
  let values = value.filter((val) => val !== "");
  return values;
};

export const remAccents = (cadena) => {
  var chars = {
    á: "a",
    é: "e",
    í: "i",
    ó: "o",
    ú: "u",
    à: "a",
    è: "e",
    ì: "i",
    ò: "o",
    ù: "u",
    ñ: "n",
    Á: "A",
    É: "E",
    Í: "I",
    Ó: "O",
    Ú: "U",
    À: "A",
    È: "E",
    Ì: "I",
    Ò: "O",
    Ù: "U",
    Ñ: "N",
  };
  var expr = /[áàéèíìóòúùñ]/gi;
  var res = cadena.replace(expr, function (e) {
    return chars[e];
  });
  return res;
};

export const objectToQueryString = (obj) => {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};

export function isObjEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) return false;
  }

  return true;
}

export const getYoutubeVideoId = (url) => {
  const regex =
    /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|&v(?:i)?=))([^#&?]*).*/;
  let result = url.match(regex);
  return result[1];
};

// ref is a reference to a HTML element we want to scroll
export const scrollToSection = (ref) => {
  if (ref.current) {
    window.scrollTo({
      top: ref.current.offsetTop,
      behavior: "smooth",
    });
  }
};

//Separar los valores de una hora, para obtener por separado, la hora, el minuto y el segundo.
//Params: fullHour:hora completa en formato hh:mm:ss
//outputSegment: segmento de salida: 1=hora, 2=minutos, 3=segundos

export const disjoinTime = (fullHour, outputSegment) => {
  var time = fullHour,
    matchesStart = time.toLowerCase().match(/(\d{1,2}):(\d{2}):(\d{2})/),
    hour = parseInt(matchesStart[1]) + (matchesStart[3] === "pm" ? 12 : 0),
    min = parseInt(matchesStart[2]),
    sec = parseInt(matchesStart[3]);

  if (outputSegment === 3) {
    return sec;
  } else if (outputSegment === 2) {
    return min;
  } else if (outputSegment === 1) {
    return hour;
  } else {
    return fullHour;
  }
  //output  = (parseInt(matches[1]) + (matches[3] === 'pm' ? 12 : 0)) + ':' + matches[2]+ ':' + matches[3];
};

//num es un string
export const maskCurrency = (num) => {
  let newNum = parseFloat(num).toFixed(2);

  let array = newNum.split(".");
  return (
    array[0].replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ") +
    "," +
    array[1]
  );
};

export const maskNumber = (num) => {
  return num.replace(/\D/g, "");
};
